/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Enrollment_RequiredInputs */

const en_error_mfa_enrollment_required = /** @type {(inputs: Error_Mfa_Enrollment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a second step to your account first.`)
};

/**
* | output |
* | --- |
* | "Add a second step to your account first." |
*
* @param {Error_Mfa_Enrollment_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_enrollment_required = /** @type {((inputs?: Error_Mfa_Enrollment_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Enrollment_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_enrollment_required(inputs)
});